
class SendSaveUserInfoController {

  constructor($uibModalInstance, $rootScope, $scope, LoadedModel, $uibModal, $cookies) {
    this._$cookies = $cookies;
    this._$rootScope = $rootScope;
    this._$uibModal = $uibModal;
    this._$scope = $scope;
    this.model = LoadedModel;
    this.model.cleanUserDetails();
    this._$uibModalInstance = $uibModalInstance;
    this._captchaValidate = () => Promise.reject();
  }

  onCaptchaInit(validate) {
    this._captchaValidate = validate;
  }

  ok(form) {
    if (form.$valid) {
      this._captchaValidate().then(() => {
        this.requestInProgress = this.model.requestInProgress = true;
        this.model.saveUserDetails();
        this._$uibModalInstance.close();
      }, () => this.catpchaIsInvalid  = true);
    }
  }
}

SendSaveUserInfoController.$inject = ['$uibModalInstance', '$rootScope', '$scope', 'LoadedModel', '$uibModal', '$cookies'];

export default SendSaveUserInfoController;



// WEBPACK FOOTER //
// ./client/app/components/home/save-user-info-modal.controller.js